import { Button } from "@similarweb/ui-components";

import { useTranslation } from "pro-features/components/WithTranslation";

interface IActionsProps {
    disabled: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    isLoading: boolean;
    subscribed: boolean;
}

export const Actions = (props: IActionsProps) => {
    const translate = useTranslation();
    return (
        <>
            <Button
                isDisabled={props.disabled}
                type="flat"
                onClick={props.onCancel}
            >
                {translate("monitor_and_protect.shared.alerts_modal.cancel_button")}
            </Button>
            <Button
                type="primary"
                isDisabled={props.disabled}
                onClick={props.onConfirm}
                isLoading={props.isLoading}
            >
                {props.subscribed
                    ? translate("monitor_and_protect.shared.alerts_modal.unsubscribe_action")
                    : translate("monitor_and_protect.shared.alerts_modal.subscribe_action")}
            </Button>
        </>
    );
};
